module.exports = __webpack_public_path__ + "img/tuition_layout4.9ff3592d.png";